/* src/app/modules/invoice/subvention/amortisation/subvention-amortisation-table-dialog.component.css */
.am-header-text {
  min-width: 0;
  padding-right: 32px;
}
.am-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.am-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.am-kpi--highlight {
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-color: #e5f3a0;
}
.am-kpi__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #6b7280;
}
.am-kpi__value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.am-table-wrap {
  max-height: 46vh;
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.am-table {
  width: 100%;
  min-width: 460px;
  font-size: 13px;
}
.am-table th.mat-mdc-header-cell {
  background: #f4f6f8;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.am-num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.am-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.am-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
/*# sourceMappingURL=subvention-amortisation-table-dialog.component.css.map */
